// extracted by mini-css-extract-plugin
module.exports = {"paragraphContainer":"AboutContent_paragraphContainer__jLUne","skillsSection":"AboutContent_skillsSection__Uetbi","sectionHeading":"AboutContent_sectionHeading__1T0Md"};